import { render, staticRenderFns } from "./AccountForgotPasswordForm.vue?vue&type=template&id=6b63d960&scoped=true&"
import script from "./AccountForgotPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./AccountForgotPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountForgotPasswordForm.vue?vue&type=style&index=0&id=6b63d960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63d960",
  null
  
)

export default component.exports